import { Change } from './change.ts';


export function getSimpleChange<T>(
    newValue: T | undefined,
    oldValue: T | undefined,
    path: string[],
): Change | null {
    const hasNewValue = newValue != null && newValue !== '';
    const hasOldValue = oldValue != null && oldValue !== '';

    if (hasNewValue && !hasOldValue) {
        return {
            path,
            changeDescription: getAddDescription(newValue),
            changeType: 'add'
        }
    } else if (!hasNewValue && hasOldValue) {
        return {
            path,
            changeDescription: getRemoveDescription(oldValue),
            changeType: 'remove'
        }
    } else if (newValue !== oldValue) {
        return {
            path,
            changeDescription: getModifyDescription(oldValue, newValue),
            changeType: 'modify'
        }
    } else {
        return null;
    }
}

export function getFieldChange<T>(
    newObject: T | undefined,
    oldObject: T | undefined,
    fieldName: keyof T,
    path: string[],
): Change | null {
    const newValue = newObject?.[fieldName];
    const oldValue = oldObject?.[fieldName];
    return getSimpleChange(newValue, oldValue, path);
}

function getAddDescription(newValue: any): string {
    return '' + newValue;
}

function getModifyDescription(oldValue: any, newValue: any): string {
    return `${oldValue ?? '___'} → ${newValue ?? '___'}`;
}

function getRemoveDescription(oldValue: any): string {
    return '' + oldValue;
}
